import { useEffect } from 'react';
import { useRouter } from 'next/router';

import useRouterQuery from '@/utils/hooks/utils/useRouterQuery';
// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Lib
import { CAMPAIGNS_QUERY_ACTION_PARAM } from '@/lib/albums/queryParams';

import type { ModalProps } from '@/components/base/Modal';
// Components
import AlbumFunnelModal from '@/components/pages/albums/AlbumFunnelModal';

type AlbumsPageWrapperProps = {
    children: (args: { toggleAlbumFunnel: ModalProps['onDismiss'] }) => React.ReactNode;
};

const AlbumsPageWrapper = ({ children }: AlbumsPageWrapperProps) => {
    const { isOpen: isOpenAlbumFunnel, toggle: toggleAlbumFunnel } = useToggle();

    const router = useRouter();
    const queryAction = router.query[CAMPAIGNS_QUERY_ACTION_PARAM.NAME];
    const { deleteQuery } = useRouterQuery();

    useEffect(() => {
        if (queryAction === CAMPAIGNS_QUERY_ACTION_PARAM.VALUES.TRACK_CAMPAIGN) {
            toggleAlbumFunnel();
            const newUrl = deleteQuery(CAMPAIGNS_QUERY_ACTION_PARAM.NAME);
            router.replace(newUrl);
        }
    }, [queryAction]);

    return (
        <>
            {children({ toggleAlbumFunnel })}
            <AlbumFunnelModal isOpen={isOpenAlbumFunnel} toggle={toggleAlbumFunnel} />
        </>
    );
};

export default AlbumsPageWrapper;
